export default "__VITE_ASSET__BA834TXp__"